import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor() {}

  // 랜덤한 doc 아이디 만들기
  generateFilename() {
    let length = 10;
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text + new Date().valueOf();
  }

  // db에 맞는 날짜 저장
  dateFormat(date: string) {
    return new Date(date).toISOString();
  }

  // 관리자 페이지에서 사용하는 input time에서 사용하는 값에 맞게 변환
  timeFormat(date: string) {
    return dayjs(date).format('HH:mm');
  }
}
